<template>
  <div class="mb-4">
    <v-textarea
      data-private
      auto-grow
      no-resize
      outlined
      dense
      rows="3"
      :maxlength="140"
      :counter="140"
      :placeholder="label"
      @input="$emit('commentChanged', $event)"
    >
    </v-textarea>
  </div>
</template>

<script>
export default {
  name: 'Comment',
  props: {
    label: {
      type: String,
      required: true,
    },
    comment: {
      type: String,
      required: true,
    },
  },
}
</script>
